import React, {useState} from "react";

function DaysBar({handleDaysBarHeight, barHeight, dayItem}) {

  const [days] = useState(["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"])  

  return (
    <>
      <div className="days_container">
        <div className="days_name">
          {
            days.map((day, index) => {
        
              return (
                <p key={index} onClick={() => handleDaysBarHeight(day)}
                  style={{ cursor: "pointer", color: `${dayItem === day ? "#fba922": "#000"}`}}>{day}</p>
              )
            })
          }
        </div>
        <div className="days_line_bar">
          <div className="days_load_bar">
            <strong className="days_load_bar_line" style={{ height: `${barHeight}%` }}>
            </strong>
          </div>
        </div>
      </div>
    </>
  );
}

export default DaysBar;
